import { sanitizeHTML } from '../functions/sanitize';

export default class WCArchiveLoadMore {
    constructor() {
        this.paged = 1;
        this.loadedAllProducts = false;

        this.loadMoreIndicator = document.querySelector(
            '.jsWcaLoadMoreIndicator',
        );

        this.productsGrid = document.querySelector('.jsWcArchiveGrid');

        if (this.productsGrid && this.loadMoreIndicator) {
            this.events();
        }
    }

    events() {
        this.startWithObserver(this.loadMoreIndicator, {
            rootMargin: '0px 0px 0px 0px',
        });
    }

    startWithObserver(observedElement, observedElementOptions) {
        const current = this;
        const countersObserverOptions = observedElementOptions;

        this.observer = new IntersectionObserver(function (entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    current.loadMoreProducts();
                }
            });
        }, countersObserverOptions);

        this.observer.observe(observedElement);
    }

    loadMoreProducts() {
        if (this.loadedAllProducts) return;

        const taxonomy = this.productsGrid.dataset.archiveTax
            ? this.productsGrid.dataset.archiveTax
            : '';

        const term = this.productsGrid.dataset.archiveTerm
            ? this.productsGrid.dataset.archiveTerm
            : '';

        const currentUrl = window.location.href;

        const ajaxData = {
            security: window.global.security,
            pagination: this.paged,
            taxonomy,
            term,
            currentUrl,
        };

        this.loadMoreIndicator.innerText =
            this.loadMoreIndicator.dataset.loadMoreText;

        fetch(window.global.ajax_url + '?action=loadMoreProductsAjax', {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: new URLSearchParams(ajaxData),
        })
            .then((resp) => resp.json())
            .then((res) => {
                this.loadMoreIndicator.innerText = '';

                if (res.success) {
                    if (res.data && res.data !== 'no-more') {
                        this.paged++;
                        this.productsGrid.innerHTML += sanitizeHTML(res.data);

                        this.productsGrid.dispatchEvent(
                            new CustomEvent('addedNewProductsToGrid'),
                        );
                    } else if (res.data === 'no-more') {
                        this.loadedAllProducts = true;
                    }
                }
            })
            .catch((err) => {
                console.error(err);
                this.loadMoreIndicator.innerText = '';
            });
    }
}
